import './cas.login-system.less';
import AbstractLoginSystem from '../abstract-login-system';
import AbstractLoginSystemController from '../abstract-login-system-controller';
import type {IWindowService} from 'angular';
import type WalkerService from '../../../../commons/services/walker.service';

export class CasLoginSystemComponentController extends AbstractLoginSystemController {

    /*@ngInject*/
    constructor(private $window: IWindowService, private walker: WalkerService) {
        super();
    }

    public redirect() {
        this.walker.newPageOnContext(`/login/cas?redirect=${encodeURIComponent(this.$window.location.href)}`);
    }
}

// eslint-disable-next-line
export default class CasLoginSystemComponent extends AbstractLoginSystem {
    public static componentName = 'cas.loginSystem';

    public templateUrl = require('./cas.login-system.tpl.ftl');

    public controller = CasLoginSystemComponentController;
}
